// Helper sort dùng chung (tách từ scholarshipAdd.vue khi gỡ page đó).
// LƯU Ý: sortByAlphabet chỉ dùng cho field CHỮ (toUpperCase) — field SỐ sẽ throw
// (list rỗng âm thầm nếu bị .catch nuốt); field số dùng sortByNumber.
export function sortByAlphabet(arr: any, keyword: string) {
  return arr?.sort(function (a: any, b: any) {
    let textA = a[keyword]?.toUpperCase();
    let textB = b[keyword]?.toUpperCase();
    return textA?.localeCompare(textB);
  });
}

export function sortByNumber(arr: any, keyword: string, order?: string) {
  if (order == "DESC") {
    return arr?.sort((a: any, b: any) =>
      Number(a[keyword]) < Number(b[keyword]) ? 1 : Number(b[keyword]) < Number(a[keyword]) ? -1 : 0
    );
  }
  return arr?.sort((a: any, b: any) =>
    Number(a[keyword]) > Number(b[keyword]) ? 1 : Number(b[keyword]) > Number(a[keyword]) ? -1 : 0
  );
}
